let sliderSetting = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
};

let style = {
  gray1: "#F9F9F9",
  gray2: "#C4C4C4",
  gray3: "#9d9d9d",
  blue1: "#E6F7FF",
  blue2: "#1890FF",
  blue3: "#D4EDFF",
  green1: "#F6FFED",
  green2: "#389E0D",
  red1: "#FFF2F0",
  red2: "#FF4D4F",
  orange1: "#FFFBE6",
  orange2: "#D48806",
  inputFontSize: 16,
};

export { sliderSetting, style }; 